
































































































































































































































































































































































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import EventBus, { Event } from '@/event.bus';
import DateFormat from '@/shared/utils/date-format';
import CustomerService from '@/domain/customer/service/customer.service';
import Customer from '@/domain/customer/entity/customer.entity';
import ContractFilter from '@/domain/contract/entity/contract-filter.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import ResultCenter from '@/domain/business-unit/entity/result-center.entity';
import SearchCustomerComponent from '@/shared/search/customer-search.component.vue';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import EnumObject from '@/domain/enum-object.entity';
import Pagination from '@/domain/pagination.entity';
import moment from 'moment';
import RuleGroupService from '@/domain/scripts/service/rule-group.service';
import RuleGroupFilter from '@/domain/scripts/entity/rule-group-filter.entity';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import RuleGroupResponse from '@/domain/scripts/entity/rule-group-response';
import SearchCustomComponent from '@/shared/search/search-custom.component.vue';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import RobotFilterType from '@/domain/contract/entity/robot-filter-type.enum';
import ContractGroupService from '@/domain/contract/service/contract-group.service';
import ContractGroupSearch from '@/domain/contract/entity/contract-group-search.entity';
import toDocument from '@/shared/directive/toDocument';
import { DOCUMENT_MASKS } from '@/shared/utils/cnpj';
import { contractGroupLinkedTypeOptions } from '@/domain/contract/entity/contract-group-linked-type.enum';
import { billingDailyFilterTypeOptions } from '@/domain/contract/entity/billing-daily-filter-type.enum';
import { billingAnniversarFilterTypeOptions } from '@/domain/contract/entity/billing-anniversary-filter-type.enum';
import { contractPeriodFilterTypeOptions } from '@/domain/contract/entity/contract-period-filter-type.enum';
import ContractStatus from './contract-status.json';
import CustomerOptions from './customer-options.json';
import ContractModel from './contract-model.json';

@Component({
  filters: {
    toDocument(value: String): String {
      if (value.length === 14) {
        return toDocument(value);
      }
      return value;
    },
  },
  components: { MainButton, SearchCustomerComponent, SearchCustomComponent },
})
export default class FilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  locale = 'pt-BR';

  anniversarySelectedDates: Array<string> = [];

  selectedDate: Array<string> = [];

  expiresAtDates: Array<string> = [];

  customers: Array<Customer> = [];

  contractGroups: Array<ContractGroupSearch> = [];

  beneficiaries: Array<Customer> = [];

  customerFetch: string = '';

  contractStatus: Array<EnumObject> = EnumObject.ofList(ContractStatus);

  contractModel: Array<EnumObject> = EnumObject.ofList(ContractModel);

  filter: ContractFilter = new ContractFilter({});

  ref: any = this.$refs;

  lastFilteredName: string = '';

  lastFilteredBeneficiary = '';

  customerOptions = CustomerOptions;

  resultCenters: Array<ResultCenter> = [];

  simOuNaoOptions = [
    {
      text: 'SIM',
      value: true,
    },
    {
      text: 'NÃO',
      value: false,
    },
  ];

  contractPeriodFilterTypeOptions = contractPeriodFilterTypeOptions;

  markedToExpireOptions = this.simOuNaoOptions;

  isCustomBillingOptions = this.simOuNaoOptions;

  isReviewedOptions = this.simOuNaoOptions;

  frequencyOptions = [
    {
      text: 'Parcelas Fixas',
      value: 'SINGLE',
    },
    {
      text: 'Mensal',
      value: 'MONTHLY',
    },
    {
      text: 'Trimestral',
      value: 'QUARTERLY',
    },
    {
      text: 'Semestral',
      value: 'HALF_YEARLY',
    },
    {
      text: 'Anual',
      value: 'ANNUAL',
    },
    {
      text: 'Valor/Hora',
      value: 'HOURS',
    },
  ];

  robotErrorTypes = [
    { text: 'Não', value: RobotFilterType.NONE },
    { text: `Sim, trazer apenas contratos com erro no robô em ${moment().locale('pt-BR').format('MMM/YYYY')}`, value: RobotFilterType.CURRENT_MONTH },
    { text: `Sim, trazer apenas contratos com erro no robô em ${moment().locale('pt-BR').subtract(1, 'months').format('MMM/YYYY')}`, value: RobotFilterType.PAST_MONTH },
  ];

  contractGroupLinkedTypeOptions: any[] = contractGroupLinkedTypeOptions;

  billingDailyFilterTypeOptions: any[] = billingDailyFilterTypeOptions;

  billingAnniversarFilterTypeOptions: any[] = billingAnniversarFilterTypeOptions;

  productIds: string = '';

  lastFilteredRuleGroup: string = '';

  ruleGroupList: Array<RuleGroup> = [];

  ruleGroupFilter: RuleGroupFilter = RuleGroupFilter.of({});

  enableRevisionFlow: Boolean = false;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  })

  updateFilterField(field: string, value: string) {
    this.filter[field] = value;
  }

  updateFilterRuleGroupField(field: string, value: string) {
    this.ruleGroupFilter[field] = value;
  }

  get customerItemText() {
    return this.filter.isTradingNameFetch
      ? 'tradingName' : 'name';
  }

  get beneficiaryItemText() {
    return this.filter.isBeneficiaryTradingNameFetch
      ? 'tradingName' : 'name';
  }

  get ruleGroupItemText() {
    return this.ruleGroupFilter.selectedRuleGroupOption
      ? 'status.description' : 'name';
  }

  ruleGroupOptions = [
    {
      value: 'name',
      description: 'Agrupamento',
    },
  ];

  clear() {
    this.filter = new ContractFilter({});
    this.ruleGroupFilter = RuleGroupFilter.of({});
    this.selectedDate = [];
    this.expiresAtDates = [];
    this.anniversarySelectedDates = [];
    this.$router.push('/contracts')
  }

  send() {
    this.filter.selectedDates = this.selectedDate;
    this.filter.expiresAtDates = this.expiresAtDates;
    this.filter.ruleGroupIds = this.ruleGroupFilter.ruleGroupIds;
    this.filter.anniversarySelectedDates = this.anniversarySelectedDates;
    this.$emit('filter', this.filter);
  }

  private formatDate(dates: Array<string>): Array<string> {
    if (dates && dates.length === 2) {
      return dates.map((el: string) => DateFormat.timestampToLocal(el));
    }
    return [];
  }

  setExpiresAtDates() {
    const dateIsBefore = moment(this.expiresAtDates[1]).isBefore(this.expiresAtDates[0]);
    if (dateIsBefore) {
      this.expiresAtDates.reverse();
    }
  }

  setSelectedDate() {
    const dateIsBefore = moment(this.selectedDate[1]).isBefore(this.selectedDate[0]);
    if (dateIsBefore) {
      this.selectedDate.reverse();
    }
  }

  setAnniversarySelectedDates() {
    const dateIsBefore = moment(this.anniversarySelectedDates[1])
      .isBefore(this.anniversarySelectedDates[0]);
    if (dateIsBefore) {
      this.anniversarySelectedDates.reverse();
    }
  }

  get expiresAtRangeText() {
    return this.formatDate(this.expiresAtDates).join(' ~ ');
  }

  get dateRangeText() {
    return this.formatDate(this.selectedDate).join(' ~ ');
  }

  get anniversaryRangeText() {
    return this.formatDate(this.anniversarySelectedDates).join(' ~ ');
  }

  checkAndApplyUrlFilter(): void {
    if (this.$route.params.status) {
      this.filter.status = this.$route.params.status;
    }
  }

  @Watch('businessUnitId')
  getResultCenters(): void {
    BusinessUnitService.getResultCenters(this.businessUnitId)
      .then((response) => this.resultCenters = response);
  }

  isNumberOrComma(evt) {
    evt = evt || window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode < 48 || charCode > 57) && charCode !== 44) {
      return evt.preventDefault();
    }
    return true;
  }

  created() {
    this.checkAndApplyUrlFilter();
    this.getCustomers(this.customerFetch);
    this.getContractGroups();
    this.getResultCenters();
    this.enableRevisionFlow = UserBusinessUnitService.currentBusinessUnit.enableRevisionFlow;
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      this.enableRevisionFlow = businessUnit.enableRevisionFlow;
    });

    if (this.$route.query.expiresAtStart && this.$route.query.expiresAtEnd) {
      this.expiresAtDates = [
        DateFormat.formatToIsoDate(this.$route.query.expiresAtStart.toString()),
        DateFormat.formatToIsoDate(this.$route.query.expiresAtEnd.toString()),
      ]
    }
    if (this.$route.query.periodStart && this.$route.query.periodEnd) {
      this.selectedDate = [
        DateFormat.formatToIsoDate(this.$route.query.periodStart.toString()),
        DateFormat.formatToIsoDate(this.$route.query.periodEnd.toString()),
      ]
    }

    if (this.$route.query.anniversaryPeriodStart && this.$route.query.anniversaryPeriodEnd) {
      this.anniversarySelectedDates = [
        DateFormat.formatToIsoDate(this.$route.query.anniversaryPeriodStart.toString()),
        DateFormat.formatToIsoDate(this.$route.query.anniversaryPeriodEnd.toString()),
      ]
    }
  }

  @Watch('businessUnitId')
  getContractGroups() {
    if (this.businessUnitId === undefined) return;
    ContractGroupService.getAll(this.businessUnitId)
      .then((response: any) => this.contractGroups = response);
  }

  get formattedAnniversary(): string {
    if (!this.anniversarySelectedDates || this.anniversarySelectedDates.length === 0) return '';
    return DateFormat.timestampToLocal(this.anniversarySelectedDates[0]);
  }

  getContractGroupText(item: ContractGroupSearch): string {
    if (item.cnpj.length === 14) {
      return `${toDocument(item.cnpj)} - ${item.name}`;
    }
    return `${item.cnpj} - ${item.name}`;
  }

  getCustomers(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredName) {
      this.lastFilteredName = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.filter.selectedCustomerOption, this.businessUnitId)
        .then((response: any) => {
          this.customers = Customer.ofList(response.content)
        });
    }
  }

  getBeneficiaries(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredBeneficiary) {
      this.lastFilteredBeneficiary = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.filter.selectedBeneficiaryOption, '')
        .then((response: any) => {
          this.beneficiaries = Customer.ofList(response.content)
        });
    }
  }

  getRuleGroup(ruleGroupFilter: string) {
    if ((ruleGroupFilter && ruleGroupFilter.length >= 3)
      && (ruleGroupFilter !== this.lastFilteredRuleGroup)) {
      this.lastFilteredRuleGroup = ruleGroupFilter;
      RuleGroupService.filterRulesGroup(this.pagination, this.businessUnitId, this.ruleGroupFilter)
        .then((response: any) => {
          const listResponse = RuleGroupResponse.ofList(response.content);
          this.ruleGroupList = RuleGroup.ofList(listResponse);
        });
    }
  }

  get mask() {
    return DOCUMENT_MASKS;
  }
}
